const getEditUser = (state) => {
  return state.editUser;
};

export default {
  getEditUser,
};
